import React from 'react';
import './App.css';
function App() {
  return (
    <div className="App">
      <header className="site-header">
        <p className="university-name">Syracuse University</p>
        <h1>Newhouse<br /><span>Synthetic Media Lab</span></h1>
        <div className="header-meta"><span>Research tools &amp; applications</span></div>
      </header>
      <main id="main-links" aria-label="Lab applications">
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://chateval.newhousesyntheticmedialab.com/try">
            <span className="link-content">
              <span className="link-title">ChatEval Voice Demo</span>
              <span className="link-description">Choose or create a scenario, talk with an AI caller, and watch a live traffic-light assessment of the conversation. Cloudflare sign-in required.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://watch.newhousesyntheticmedialab.com/">
            <span className="link-content">
              <span className="link-title">Generator Watch</span>
              <span className="link-description">Follow image-generator releases, explore detector coverage, and track training updates. Syracuse sign-in or approved guest access required.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://image-origin.newhousesyntheticmedialab.com/">
            <span className="link-content">
              <span className="link-title">Image Origin Lab</span>
              <span className="link-description">Explore real-versus-AI image classification and likely generator families. Restricted research-team access.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://invoke.newhousesyntheticmedialab.com/">
            <span className="link-content">
              <span className="link-title">InvokeAI</span>
              <span className="link-description">Generate and edit images with the lab’s installed AI models, canvas tools, and workflows. Sign-in required.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://openwebui-m.newhousesyntheticmedialab.com/">
            <span className="link-content">
              <span className="link-title">Open WebUI</span>
              <span className="link-description">Chat with different AI models, compare responses, and explore research questions in one workspace.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://cloud-m.newhousesyntheticmedialab.com/">
            <span className="link-content">
              <span className="link-title">Cloud Storage</span>
              <span className="link-description">Upload, download, and organize files in the lab’s shared storage.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://cloud-m.newhousesyntheticmedialab.com/?u=media_gen&p=apVXrR">
            <span className="link-content">
              <span className="link-title">Media Repository</span>
              <span className="link-description">Browse and download media files from the lab’s collection.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://quality-m.newhousesyntheticmedialab.com/">
            <span className="link-content">
              <span className="link-title">Anti Forensics Tool</span>
              <span className="link-description">Create altered image copies with noise, compression, color changes, and camera metadata for research.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://jupyter-m.newhousesyntheticmedialab.com/">
            <span className="link-content">
              <span className="link-title">JupyterHub</span>
              <span className="link-description">Run Python notebooks for coding, data analysis, and machine learning with access to the lab’s GPUs.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://imgauthv2.newhousesyntheticmedialab.com/">
            <span className="link-content">
              <span className="link-title">AI Image Detector V2</span>
              <span className="link-description">Evaluate images for signs of AI generation, analyze batches, and download detection reports.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://textdetector-m.newhousesyntheticmedialab.com/">
            <span className="link-content">
              <span className="link-title">Text Detector Model</span>
              <span className="link-description">Analyze text with trained classifiers for profiles and news articles, individually or in batches.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://roop.newhousesyntheticmedialab.com/">
            <span className="link-content">
              <span className="link-title">ROOP Unleashed</span>
              <span className="link-description">Swap faces in photos and videos, with controls for face selection and output processing.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://scraper.newhousesyntheticmedialab.com/">
            <span className="link-content">
              <span className="link-title">Reddit Scraper</span>
              <span className="link-description">Collect Reddit images using subreddit, date, text, and image-similarity filters, then export files and metadata.</span>
            </span>
          </a>
        </div>
        <div className="box">
          <a target="_blank" rel="noopener noreferrer" href="https://chateval.newhousesyntheticmedialab.com/">
            <span className="link-content">
              <span className="link-title">ChatEval</span>
              <span className="link-description">Create and review multi-turn AI conversations for research, with scenarios, annotations, and dataset exports.</span>
            </span>
          </a>
        </div>
      </main>
      <footer className="site-footer">Newhouse Synthetic Media Lab <span>Syracuse University</span></footer>
    </div>
  );
}
export default App;
